<template>
  <div class="repairOrder">
    <el-form
        class="custom-formScreen"
        :model="formScreen"
        ref="formScreen"
        label-width="100px"
        inline
    >
      <el-form-item label="处理状态" prop="solveType">
        <el-select v-model="formScreen.solveType" placeholder="请选择">
          <el-option
              v-for="item in listType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子公司" prop="selectCompanyId" v-if="this.UserInfo.system == 5  && this.UserInfo.superDepartmentName == '客服部'  ||   this.UserInfo.system == 5  &&this.UserInfo.superDepartmentName == '仓库客服部'  ||this.UserInfo.system == 5 && this.UserInfo.superDepartmentName == '常规客服部'">
        <el-select v-model="formScreen.selectCompanyId" @change="selectCompany" placeholder="请选择" filterable>
          <el-option
              v-for="item in selectCompanyIdList"
              :key="item.id"
              :label="item.companyFullName"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="员工" prop="selectRid" v-if="this.UserInfo.system == 5  &&  this.UserInfo.superDepartmentName == '客服部'  || this.UserInfo.system == 5  &&  this.UserInfo.superDepartmentName == '仓库客服部'  ||  this.UserInfo.system == 5  && this.UserInfo.superDepartmentName == '常规客服部'  || this.UserInfo.system == 5  && this.UserInfo.superDepartmentName == '采购部'">
        <el-select v-model="formScreen.selectRid" placeholder="请选择" filterable>
          <el-option
              v-for="item in selectRidList"
              :key="item.rid"
              :label="item.roleName+'-'+item.userName"
              :value="item.rid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startTime">
        <el-date-picker
            v-model="formScreen.startTime"
            align="right"
            type="datetime"
            placeholder="选择开始日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="endTime">
        <el-date-picker
            v-model="formScreen.endTime"
            align="right"
            type="datetime"
            placeholder="选择结束日期"
            format="yyyy-MM-dd HH:mm:ss"
             value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item prop="isSortByReplyTime" label=" ">
        <el-checkbox v-model="formScreen.isSortByReplyTime">根据回复时间排序</el-checkbox>
      </el-form-item>
      <el-form-item prop="searchVal" label=" " style="width: 40%">
        <el-input
            @input="ChangeOrder"
            placeholder="请输入订单号/问题描述"
            v-model="formScreen.searchVal"
            style="width: calc(100% - 140px);"
        ></el-input>
        <el-button type="primary" style="margin-left: 10px;" @click="searchForm">搜索</el-button>
        <el-button type="primary" @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row
        style="margin: 10px 0;"
        v-if="UserInfo.system === 5 && UserInfo.superDepartmentName === '运营部'"
    >
      <el-button type="primary" @click="createRepairOrder">创建工单</el-button>
    </el-row>

    <el-table :data="listTable" border v-loading="loadingTable">
      <el-table-column label="工单类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 1">ERP问题</span>
          <span v-else-if="scope.row.type === 2">运营问题</span>
          <span v-else-if="scope.row.type === 3">物流问题</span>
          <span v-else-if="scope.row.type === 4">采购问题</span>
        </template>
      </el-table-column>
      <el-table-column prop="amazonOrderId" label="订单号" align="center"></el-table-column>
      <el-table-column show-overflow-tooltip prop="problemRemark" label="问题描述" align="center"></el-table-column>
      <el-table-column show-overflow-tooltip prop="lastReply" label="最新回复" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
      <el-table-column prop="lastReplyTime" sortable label="回复时间" align="center"></el-table-column>
      <el-table-column label="处理状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.solveType === 0" style="color: red;">未处理</span>
          <span v-else-if="scope.row.solveType === 1" style="color: #0f59a4;">处理中</span>
          <span v-else-if="scope.row.solveType === 2">已完结</span>
        </template>
      </el-table-column>
      <el-table-column prop="createRoleUserName" label="创建角色" align="center"></el-table-column>
      <el-table-column prop="companyFullName" label="所属子公司" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button type="primary" @click="seeRepairOrder(scope)">查看</el-button>
          <el-button type="primary" @click="changRepairOrder(scope.row)" v-if="isChangeRepairOrder">转工单</el-button>
          <el-button type="primary" @click="restartOrder(scope.row)" v-if="applicable === 1 && scope.row.solveType === 2">重启</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-row class="pagination-box" type="flex" justify="center" align="middle">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[20, 50, 100, 200, 400]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </el-row>

   <el-dialog :title="dialogType === 'create' ? '创建工单' : '查看工单'" :visible.sync="dialogVisible" width="40%" top="4vh"
               @close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="formDialog" ref="formDialog" size="mini">
        <el-form-item label="工单类型" prop="type" label-width="90px">
          <el-radio-group v-model="formDialog.type" :disabled="dialogType === 'see'" @change="handleRadioChange">
            <el-radio :label="1">ERP问题</el-radio>
            <el-radio :label="2">运营问题</el-radio>
            <el-radio :label="3">物流问题</el-radio>
            <el-radio :label="4">采购问题</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="亚马逊单号" prop="amazonOrderId" label-width="90px">
          <el-input v-model="formDialog.amazonOrderId" :disabled="dialogType === 'see'"></el-input>
        </el-form-item>
        <el-form-item v-if="dialogType !== 'see'">
          <el-upload
              multiple
              ref="upload"
              :action="action"
              list-type="picture-card"
              :on-success="handleAvatarSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :headers="customHeaders"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item v-else-if="formDialog.problemImageList.length">
          <template v-for="(item,index) in formDialog.problemImageList">
            <el-image
                class="img-item"
                :src="item"
                :key="index"
                :preview-src-list="formDialog.problemImageList"
            ></el-image>
          </template>
        </el-form-item>
        <el-form-item prop="problemRemark">
          <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="formDialog.problemRemark"
              v-if="dialogType !== 'see'"
          ></el-input>
          <div v-else>{{ formDialog.problemRemark }}</div>
        </el-form-item>
      </el-form>

      <template v-if="dialogType === 'see'">
        <div class="reply-box" v-show="dialogRepairOrderInfo.talkList.length">
          <div v-for="item in dialogRepairOrderInfo.talkList" :key="item.id">
            <el-row type="flex">
              <div class="title-box">{{ item.createRoleUserName }}</div>
              <div class="date-box">{{ item.createTime }}</div>
            </el-row>
            <div class="content-box">
              <div>{{ item.content }}</div>
              <template v-for="(key, index) in item.images">
                <el-image class="img-item" :key="index" :src="key" :preview-src-list="item.images"></el-image>
              </template>
            </div>
          </div>
        </div>
        <el-form
            :model="formDialogReply"
            ref="formDialogReply"
            v-if="dialogRepairOrderInfo.solveType !== 2"
        >
          <el-form-item>
            <el-upload
                multiple
                ref="upload2"
                :action="action"
                list-type="picture-card"
                :on-success="handleAvatarSuccess"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :headers="customHeaders"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item prop="content">
            <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入回复信息"
                v-model="formDialogReply.content"
            ></el-input>
          </el-form-item>

        </el-form>
      </template>
      <el-form>
        <el-form-item label="问题类型" label-width="80px">
          <el-select style="width: 100%;" @change="handleCommonWords" v-model="Words" value="" filterable>
            <el-option v-for="item in listCommonWord" :key="item.id" :label="item.content"
                       :value="item.content"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <template v-if="dialogRepairOrderInfo.solveType !== 2">
          <el-button
              type="danger"
              @click="endRepairOrder"
              :loading="loadingStatus === 'endRepairOrder'"
              v-if="!(UserInfo.superDepartmentName === '运营部' && UserInfo.system === 5)"
          >完结工单</el-button>
          <el-button @click="closeDialog">取 消</el-button>
          <el-button
              type="primary"
              @click="submitCreateRepairOrder"
              :loading="loadingStatus === 'creatRepairOrder'"
              v-if="dialogType === 'create'"
          >提 交</el-button>
          <el-button
              type="primary"
              @click="submitRepairOrderReply"
              :loading="loadingStatus === 'seeRepairOrder'"
              v-else-if="dialogType === 'see'"
          >提 交</el-button>
        </template>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogImgVisible" top="4vh">
      <img width="100%" :src="dialogImageUrl" alt/>
    </el-dialog>

    <el-dialog title="转移工单" :visible.sync="changeRepairOrderVisible" top="4vh">
      <el-form :inline="true">
        <el-form-item label="工单类型：">
          <el-radio-group v-model="changeRepairOrderForm.type">
            <el-radio :label="1" :disabled="changeRepairOrderRadioDisabled === 1">ERP问题</el-radio>
            <el-radio :label="2" :disabled="changeRepairOrderRadioDisabled === 2">运营问题</el-radio>
            <el-radio :label="3" :disabled="changeRepairOrderRadioDisabled === 3">物流问题</el-radio>
            <el-radio :label="4" :disabled="changeRepairOrderRadioDisabled=== 4">采购问题</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="confirmChangeRepairOrder">完 成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
  name: 'repairOrder',
  data() {
    return {
      UserInfo: {},
      action: Baseurl + "imageController/uploadImage",
      customHeaders: { token: localStorage.getItem("token") },
      page: 1,
      size: 20,
      total: 0,
      formScreen: {
        solveType: '',
        startTime: '',
        endTime: '',
        searchVal: '',
        selectRid:'',
        selectCompanyId:'',
        isSortByReplyTime:false,
      },
      listTable: [],
      loadingTable: false,
      listType: [
        { value: 0, label: "未处理" },
        { value: 1, label: "处理中" },
        { value: 2, label: "已完结" },
      ],
      selectCompanyIdList:[],
      selectRidList:[],
      dialogVisible: false,
      dialogImgVisible: false,
      dialogImageUrl: '',
      formDialog: {
        type: '',
        amazonOrderId: '',
        problemRemark: '',
        problemImageList: [],
      },
      Words:"",
      uploadImgList: [],
      loadingStatus: '',
      dialogType: 'create',
      dialogRepairOrderInfo: {},
      formDialogReply: {
        content: '',
        images: [],
      },
      changeRepairOrderVisible: false,
      changeRepairOrderRadio: '',
      changeRepairOrderForm: {
        id: '',
        type: '',
        amazonOrderId: '',
      },
      changeRepairOrderRadioDisabled: '',
      applicable: '',
      listCommonWord: [],
      ListComyanyId:"",
      Words:"",
    }
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem("role"));
    this.getListTable()
    if(this.UserInfo.system == 5&&this.UserInfo.superDepartmentName == '客服部'||this.UserInfo.system == 5&&this.UserInfo.superDepartmentName == '仓库客服部'  ||this.UserInfo.system == 5 && this.UserInfo.superDepartmentName == '常规客服部'){
      this.CompanyList()
    }
    if(this.UserInfo.system == 5&&this.UserInfo.superDepartmentName == "采购部"){
      this.ListComyanyId = this.UserInfo.company_id
      this.employeesAjax()
    }
  },
  computed: {
    isChangeRepairOrder() {
      const result1 = ['客服部', '仓库客服部', '采购部'].includes(this.UserInfo.superDepartmentName)
      const result2 = [5].includes(this.UserInfo.system)
      return (result1 && result2) || (this.UserInfo.superDepartmentName === '常规客服部' && this.UserInfo.type === 1)
    },
  },
  methods: {
      ChangeOrder(val){
          this.formScreen.searchVal = this.formScreen.searchVal.replace(/\s/g,"");
          val = val.replace(/\s/g,"");
      },
    getListTable() {
      const API = Baseurl + "workOrderController/selectWorkOrderInfo"
      const paramsData = {
        signRid: this.UserInfo.rid,
        page: this.page,
        size: this.size,
        ...this.formScreen,
      }
    //   console.log(paramsData)
      this.loadingTable = true
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingTable = false
        if (code === 200) {
        //   data.pageInfo.list.forEach(item => {
        //     if (typeof item.problemRemark === 'string' && item.problemRemark.length > 6) {
        //       item.problemRemark = item.problemRemark.slice(0, 6) + '...'
        //     }
        //     if (typeof item.lastReply === 'string' && item.lastReply.length > 6) {
        //       item.lastReply = item.lastReply.slice(0, 6) + '...'
        //     }
        //   })
          this.listTable = data.pageInfo.list;
        //   console.log(JSON.parse(JSON.stringify(this.listTable)))

          this.total = data.pageInfo.total
          this.applicable = data.state
        }
      });
    },
    searchForm() {
      this.page = 1
      this.getListTable()
    },
    resetForm() {
      this.$refs.formScreen.resetFields()
      this.getListTable()
    },
    handleSizeChange(val) {
      this.size = val;
      this.getListTable()
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getListTable()
    },
    createRepairOrder() {
      this.dialogVisible = true
      this.dialogType = 'create'
      this.dialogRepairOrderInfo = {}
    },
    //图片上传
    handleAvatarSuccess(response, file, fileList) {
      this.uploadImgList = fileList.map(item => item.response)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogImgVisible = true;
    },
    //删除要上传的图片
    handleRemove(file, fileList) {
      this.uploadImgList = fileList.map(item => item.response)
    },
    submitCreateRepairOrder() {
      if (this.formDialog.type === "") {
        this.$message.warning('请选择工单类型');
      } else if(this.Words === ""){
        this.$message.warning('请选择问题类型');
      }else {
        if (this.formDialog.type !== 1 && !this.formDialog.amazonOrderId) {
          this.$message.warning('请填写亚马逊订单号');
        }else if (this.formDialog.problemRemark === "") {
          this.$message.warning('请填写内容');
        }else {
          this.formDialog.problemImageList = this.uploadImgList.map(item => item.data)
          const API = Baseurl + "workOrderController/insertWorkOrderInfo"
          const paramsData = {
            createRid: this.UserInfo.rid,
            companyId: this.UserInfo.company_id,
            ...this.formDialog,
          }
          this.loadingStatus = 'creatRepairOrder'
          ajaxPost(API, paramsData).then(res => {
            const { code, data } = res.data
            this.loadingStatus = ''
            if (code === 200) {
              this.dialogVisible = false
              this.$message.success('操作成功')
              this.getListTable()
            } else {
              this.$message.error(data);
            }
          });
        }
      }
    },
    closeDialog() {
      this.uploadImgList = []

      this.formDialog = this.$options.data().formDialog
      this.formDialogReply = this.$options.data().formDialogReply

      this.dialogType === 'create' && this.$refs.upload.clearFiles()
      this.dialogType === 'see' && this.dialogRepairOrderInfo.solveType !== 2 && this.$refs.upload2.clearFiles()
      this.dialogVisible = false
    },
    seeRepairOrder({ row }) {
      const API = Baseurl + 'workOrderController/selectWorkOrderInfoById'
      const paramsData = {
        id: row.id,
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.dialogVisible = true
          this.dialogType = 'see'

          this.formDialog.id = row.id
          this.formDialog.type = data.type
          this.formDialog.amazonOrderId = data.amazonOrderId
          this.formDialog.problemRemark = data.problemRemark
          this.formDialog.problemImageList = data.problemImageList

          this.dialogRepairOrderInfo = data

          this.getCommonWords()
        }
      })
    },
    submitRepairOrderReply() {
      if (!this.formDialogReply.content) {
        this.$message.warning('请输入回复信息')
        return
      }
      const API = Baseurl + 'talkController/insertTalkInfo'
      this.formDialogReply.images = this.uploadImgList.map(item => item.data)
      const paramsData = {
        workOrderId: this.dialogRepairOrderInfo.workOrderId,
        createRid: this.UserInfo.rid,
        ...this.formDialogReply,
      }
      this.loadingStatus = 'seeRepairOrder'
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingStatus = ''
        if (code === 200) {
          // this.dialogVisible = false
          // this.getListTable()
          this.seeRepairOrder({ row :this.formDialog })
          this.formDialogReply.content = ''
          this.$refs.upload2.clearFiles()
          this.$message.success('操作成功')

        } else {
          this.$message.error(data || '操作失败');
        }
      })
    },
    endRepairOrder() {
      if (this.formDialogReply.content) {
        this.$message.warning('还有尚未提交的内容，请先提交。')
        return
      }
      const API = Baseurl + 'workOrderController/endWorkOrderInfo'
      const paramsData = {
        id: this.dialogRepairOrderInfo.id,
      }
      this.loadingStatus = 'endRepairOrder'
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingStatus = ''
        if (code === 200) {
          this.dialogVisible = false
          this.$message.success('操作成功')
          this.getListTable()
        } else {
          this.$message.error(data || '操作失败');
        }
      })
    },
    changRepairOrder(row) {
      this.changeRepairOrderVisible = true

      this.changeRepairOrderForm.id = row.id
      this.changeRepairOrderForm.type = row.type
      this.changeRepairOrderForm.companyId = row.companyId
      this.changeRepairOrderForm.amazonOrderId = row.amazonOrderId

      this.changeRepairOrderRadioDisabled = row.type
    },
    confirmChangeRepairOrder() {
      const API = Baseurl + 'workOrderController/forwardWorkOrderInfo'
      ajaxPost(API, this.changeRepairOrderForm).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.changeRepairOrderVisible = false
          this.getListTable()
          this.$message.success(data)
        } else {
          this.$message.error(data)
        }
      })
    },
    handleRadioChange() {
      this.getCommonWords()
    },
    getCommonWords() {
      const API = Baseurl + 'commonTermsForWorkOrdersController/selectCommonTermsForWorkOrderList'
      const paramsData = {
        type: this.formDialog.type,
        applicable: this.applicable,
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listCommonWord = data
        }
      })
    },
    handleCommonWords(e) {
      if (this.dialogType === 'see') {
        this.formDialogReply.content = e
      } else {
        this.formDialog.problemRemark = e
      }
    },
    restartOrder(row) {
      const API = Baseurl + 'workOrderController/rebootWorkOrderInfo'
      const paramsData = { id: row.id }

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.$message.success('操作成功')
          this.getListTable()
        } else {
          this.$message.error(data || '操作失败')
        }
      })
    },
    CompanyList() {
      const API = Baseurl + 'roleController/selectCompanyListBySignRid'
      const paramsData = { signRid: this.UserInfo.rid }

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.selectCompanyIdList = res.data.data
        } else {
          this.$message.error(data || '操作失败')
        }
      })
    },
    selectCompany(val){
      this.ListComyanyId = val
      this.selectRidList = []
      this.employeesAjax()
    },
    employeesAjax(){
      const API = Baseurl + 'roleController/selectRoleListByCompanyId'
      const paramsData = { companyId: this.ListComyanyId }

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.selectRidList = res.data.data
        } else {
          this.$message.error(data || '操作失败')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repairOrder {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }

  .img-item {
    width: 146px;
    height: 146px;
    border-radius: 6px;
  }

  .img-item + .img-item {
    margin-left: 10px;
  }

  .reply-box {
    height: 200px;
    overflow: auto;
    border-radius: 4px;
    border: 1px solid #ccc;
    margin-bottom: 20px;
    padding: 10px;
  }

  .title-box {
    font-weight: bold;
    margin-right: 10px;
  }

  .content-box {
    padding: 10px;
  }

  .content-box .img-item {
    width: 50px;
    height: 50px;
  }
}
</style>